import React, { useEffect, useState } from "react";
import "./FarmerProfile.css";
import { IoLocationOutline } from "react-icons/io5";
import { GrGroup } from "react-icons/gr";
import { MdOutlineInsertPhoto } from "react-icons/md";
import { MdOutlineDateRange } from "react-icons/md";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { Api_Caller } from "../../../utils/Api";
import axios from "axios";
import moment from "moment";
import { useTagDownloader } from "../../visits/ImageDownloadHandler";
import ReactPaginate from "react-paginate";
import FarmerTag from "./FarmerTag";

const FarmerProfile = () => {
  const auth = useSelector((state) => state.auth || {});
  const location = useLocation();

  const mobileNumber = location.state?.mobileNumber;

  const { PagiNation, Filters } = location.state || {};

  const [pagination, setPagination] = useState(() => ({
    paginationFilter: {
      offset: 0,
      limit: 10,
      order: "DESC",
    },
  }));

  const [farmerDetails, setFarmerDetails] = useState();
  const [loading, setLoading] = useState(false);
  const { offset, limit } = pagination.paginationFilter;

  //tag
  const [selectedTag, setSelectedTag] = useState(1);
  const [showMoreTags, setShowMoreTags] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [expandedVisits, setExpandedVisits] = useState({});

  const { handleDownloadTag, isDownloading } = useTagDownloader();

  const handlePageClick = ({ selected }) => {
    setPagination((prev) => ({
      ...prev,
      paginationFilter: {
        ...prev.paginationFilter,
        offset: selected,
      },
    }));
  };

  useEffect(() => {
    let isMounted = true;
    const getFarmerDetail = async () => {
      try {
        setLoading(true);

        const params = {
          page: offset,
          size: limit,
        };

        Object.keys(params).forEach((key) => {
          if (params[key] === "" || params[key] == null) {
            delete params[key];
          }
        });

        const response = await axios.get(
          `${process.env.REACT_APP_API_ALL}/${Api_Caller.getFarmerDetails}/${mobileNumber}/visit-history`,
          {
            params,
            headers: {
              Authorization: `Bearer ${auth.accessToken}`,
            },
          },
        );

        if (isMounted) {
          setFarmerDetails(response?.data || []);
          setTotalElements(response?.data?.visits?.totalElements || 0);
        }
      } catch (error) {
        if (isMounted) {
          console.log("Error fetching farmers:", error);
          setFarmerDetails([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getFarmerDetail();

    return () => {
      isMounted = false;
    };
  }, [pagination, auth.accessToken]);

  return (
    <div className="farmer-profile-page">
      {/* Page Header */}
      <div className="fp-page-header">
        <h1>Farmer Profile</h1>

        {/* <span
          className={`collapsed cursor-pointer`}
          data-target={`#farmerfilter`}
          target={"filter"}
          data-toggle="collapse"
        >
          <Filter target={"farmerfilter"} noMargin={true} />
        </span> */}
        <NavLink
          className="back-nav"
          to="/Farmers"
          state={{
            PagiNation: PagiNation,
            Filters: Filters,
          }}
        >
          Back
        </NavLink>
      </div>

      {/* Farmer Information */}
      <section className="fp-profile-overview mb-10">
        <div className="fp-farmer-information">
          <div className="fp-farmer-main">
            <div className="fp-farmer-title">
              <h2>{farmerDetails?.farmer?.farmerName}</h2>
              <span
                className={`registration-badge ${
                  farmerDetails?.farmer?.registered
                    ? "is-registered"
                    : "not-registered"
                }`}
              >
                {farmerDetails?.farmer?.egistered
                  ? "Registered"
                  : "Not Registered"}{" "}
              </span>
            </div>

            <div className="fp-farmer-meta">
              <div className="fp-meta-item">
                <span>Farmer ID</span>
                <strong>{farmerDetails?.farmer?.customerId || "-"}</strong>
              </div>

              <div className="fp-meta-item">
                <span>Mobile Number</span>
                <strong>{farmerDetails?.farmer?.mobileNumber || "-"}</strong>
              </div>

              <div className="fp-meta-item">
                <span>Village / Location</span>
                <strong>{farmerDetails?.farmer?.villageArea || "-"}</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="fp-statistics">
          <div className="fp-stat-item">
            <IoLocationOutline className="fp-stat-icon fp-green-icon" />
            <span>Total Visits</span>
            <strong>{farmerDetails?.farmer?.totalVisits}</strong>
          </div>

          <div className="fp-stat-item">
            <GrGroup className="fp-stat-icon fp-blue-icon" />
            <span>Unique Agents</span>
            <strong>{farmerDetails?.farmer?.uniqueAgents}</strong>
          </div>

          <div className="fp-stat-item">
            <MdOutlineInsertPhoto className="fp-stat-icon fp-image-icon" />

            <span>Photos Collected</span>
            <strong>{farmerDetails?.farmer?.photosCollected}</strong>
          </div>

          <div className="fp-stat-item">
            <MdOutlineDateRange className="fp-stat-icon fp-green-icon" />
            <span>Last Visit</span>
            <strong className="fp-last-visit">
              {" "}
              {farmerDetails?.farmer?.lastVisit
                ? moment
                    .utc(farmerDetails?.farmer?.lastVisit)
                    .local()
                    .format("DD-MM-YYYY")
                : "-"}
              <br />
              {farmerDetails?.farmer?.lastVisit
                ? moment
                    .utc(farmerDetails?.farmer?.lastVisit)
                    .local()
                    .format("hh:mm A")
                : "-"}
            </strong>
          </div>
        </div>
      </section>

      {/* Visit History Filters */}

      <div className="card all-cards p-0 mb-30">
        <div className="card-header bg-white py-6">
          <h5 className="mb-0">Farmers</h5>
        </div>

        <div className="card-body table-responsive p-4">
          <div className="card-body table-responsive p-4">
            <table
              className="table table-hover align-middle mb-0 table-bordered"
              id="commontable"
            >
              <thead className="theadheading">
                <tr>
                  <th className="number-column w2">Sr. No</th>
                  <th className="w10">Field Agent</th>
                  <th className="w10">Purpose</th>
                  <th className="w10">Photos</th>
                  <th className="w10">visited At</th>
                  <th className="w10">Action</th>
                </tr>
              </thead>

              <tbody>
                {farmerDetails?.visits?.content?.length > 0 ? (
                  farmerDetails?.visits?.content?.map((farmer, index) => {
                    const id = farmer?.visitId;

                    const tagsList = farmer?.tags || [];

                    const visitTags = tagsList.map((tag, index) => ({
                      id: index + 1,
                      name: tag.tag,
                      images:
                        tag.photos?.map((photo) => ({
                          id: photo.id,
                          url: photo.photoUrl,
                          latitude: photo.latitude,
                          longitude: photo.longitude,
                        })) || [],
                    }));

                    const visibleTags = selectedTag
                      ? visitTags.filter((item) => item.id === selectedTag)
                      : visitTags.slice(0, 1);

                    return (
                      <>
                        <tr key={farmer.id}>
                          <td>{offset * limit + index + 1}</td>

                          <td>
                            <strong>{farmer?.agentName}</strong>
                          </td>
                          <td>{farmer?.purposeOfVisit}</td>
                          <td>{farmer?.photosCollected || "0"}</td>
                          <td>
                            {farmer?.visitedAt
                              ? moment
                                  .utc(farmer?.visitedAt)
                                  .local()
                                  .format("DD-MM-YYYY")
                              : "-"}
                            <br />
                            {farmer?.visitedAt
                              ? moment
                                  .utc(farmer?.visitedAt)
                                  .local()
                                  .format("hh:mm A")
                              : "-"}
                          </td>

                          <td>
                            <span
                              data-target={`#farmer_${id}_details`}
                              data-toggle="collapse"
                              className={`fp-details-label fp-details-close  ${
                                expandedVisits[id] ? "fp-details-open" : ""
                              }`}
                              onClick={() => {
                                setExpandedVisits((prev) => ({
                                  ...prev,
                                  [id]: !prev[id],
                                }));
                              }}
                            >
                              {expandedVisits[id]
                                ? "Hide Details"
                                : "View Details"}
                            </span>
                          </td>
                        </tr>

                        <tr className="collapse" id={`farmer_${id}_details`}>
                          <td colSpan="6">
                            <div className="fp-expanded-content">
                              <div className="fp-visit-details">
                                <h3>Visit Details</h3>

                                <div className="fp-detail-line">
                                  <span>Location</span>
                                  <strong>{farmer?.villageArea}</strong>
                                </div>

                                <div className="fp-detail-line">
                                  <span>Latitude</span>
                                  <strong>{farmer?.location?.latitude}</strong>
                                </div>

                                <div className="fp-detail-line">
                                  <span>Longitude</span>
                                  <strong>{farmer?.location?.longitude}</strong>
                                </div>

                                <div className="fp-detail-line">
                                  <span>Purpose</span>
                                  <strong>{farmer?.purposeOfVisit}</strong>
                                </div>

                                <div className="fp-detail-line">
                                  <span>Remarks</span>
                                  <strong>{farmer?.remarks}</strong>
                                </div>

                                <div className="fp-detail-line">
                                  <span>Notes</span>
                                  <strong>{farmer?.notes}</strong>
                                </div>
                              </div>

                              {/* <div className="fp-visit-photos">
                                <div className="fp-photos-heading">
                                  <h3>Photos ({farmer?.photosCollected})</h3>
                                </div>

                                <div className="visit-tags-list">
                                  {(showMoreTags
                                    ? visitTags
                                    : visitTags.slice(0, 4)
                                  ).map((tag) => (
                                    <button
                                      key={tag.id}
                                      className={`visit-tag-btn ${
                                        selectedTag === tag.id ? "active" : ""
                                      }`}
                                      onClick={() => {
                                        setSelectedTag(tag.id);
                                      }}
                                    >
                                      {tag.name}
                                    </button>
                                  ))}

                                  {!showMoreTags && visitTags.length > 4 && (
                                    <button
                                      className="visit-tag-btn more"
                                      onClick={() => {
                                        setShowMoreTags(true);
                                      }}
                                    >
                                      +{visitTags.length - 4} More
                                    </button>
                                  )}
                                </div>

                                <div className="visit-images-container">
                                  {visibleTags?.map((tag) => {
                                    return (
                                      <>
                                        <div
                                          className="visit-tag-group"
                                          key={tag.id}
                                        >
                                          <div className="visit-tag-group-title">
                                            <div className="visit-tag-name d-flex align-items-center">
                                              <span className="tag-line"></span>
                                              <span>{tag.name}</span>
                                            </div>

                                            <button
                                              className="visit-download-btn"
                                              disabled={isDownloading}
                                              onClick={() =>
                                                handleDownloadTag(tag)
                                              }
                                            >
                                              {isDownloading
                                                ? "Processing..."
                                                : "Download"}
                                            </button>
                                          </div>

                                          <div className="visit-image-grid">
                                            {tag?.images?.map(
                                              (image, index) => {
                                                return (
                                                  <>
                                                    <div
                                                      className="visit-image-wrappe"
                                                      key={image.id || index}
                                                    >
                                                      <div className="visit-image-wrapper">
                                                        <img
                                                          src={image?.url}
                                                          alt={`${tag.name} ${index + 1}`}
                                                        />
                                                      </div>

                                                      <span className="visit-image-label">
                                                        {index === 0
                                                          ? "Top View"
                                                          : index === 1
                                                            ? "Side View (0°)"
                                                            : "Side View (180°)"}
                                                      </span>
                                                    </div>
                                                  </>
                                                );
                                              },
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}
                                </div>
                              </div>
                             */}

                              <FarmerTag
                                farmer={farmer}
                                selectedTag={selectedTag}
                                visibleTags={visibleTags}
                                isDownloading={isDownloading}
                                setShowMoreTags={setShowMoreTags}
                                handleDownloadTag={handleDownloadTag}
                                showMoreTags={showMoreTags}
                                visitTags={visitTags}
                                setSelectedTag={setSelectedTag}
                              />
                            </div>
                          </td>
                        </tr>
                      </>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="farmers-empty">
                      No farmers found. Try changing your filters.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {!loading && totalElements > 0 && (
              <div className="mt-4">
                {totalElements > limit && (
                  <ReactPaginate
                    previousLabel="<<"
                    nextLabel=">>"
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    forcePage={offset}
                    pageCount={Math.ceil(totalElements / limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    containerClassName="pagination justify-content-center mb-0"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                    disabledClassName="disabled"
                    renderOnZeroPageCount={null}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <section className="fp-visit-section">
        {/* <div className="fp-visit-filters">
          <div className="fp-date-filter">
            <span className="fp-filter-icon">▦</span>
            <span>01 Oct 2026</span>
            <span className="fp-date-dash">–</span>
            <span>31 Oct 2026</span>
            <span className="fp-calendar-end">▦</span>
          </div>

          <div className="fp-agent-filter">
            <span>All Agents</span>
            <span className="fp-dropdown-arrow">⌄</span>
          </div>

          <div className="fp-search-filter">
            <span className="fp-search-symbol">⌕</span>
            <span>Search by purpose or remarks...</span>
          </div>
        </div> */}

        {/* Visit History Table */}
      </section>
    </div>
  );
};

export default FarmerProfile;
